import { useQuery } from "react-query";
import http from "infra/http";

function useProfissoes() {
  return useQuery(["/v1/profissao"], async () => {
    const { data } = await http.get<{ id: string; nome: string }[]>(
      "/v1/profissao"
    );

    return data;
  });
}

export default useProfissoes;
